module.exports = __webpack_public_path__ + "media/images/points_3-b3d8441a1bc77ca555861269be5a0079.svg";